module.exports = __webpack_public_path__ + "static/img/scene-1.fc5fb4fc.jpg";